import React from 'react';
import ScrollLock from 'react-scrolllock';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Filters } from './Filters';
import CloseIcon from '../../images/icon-close.inline.svg';
import { Z_INDEXES } from '../../constants';

const Modal = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${Z_INDEXES.OVERLAY};
  padding: 16px 20px;
  background: #f9f9f9;
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: none;
  width: 24px;
  height: 24px;
  padding: 0;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.13px;
  margin: 0;
`;

const FiltersModalWindow = ({ onClose }) => (
  <ScrollLock>
    <Modal>
      <CloseBtn type="button" onClick={onClose}><CloseIcon width="24px" height="24px" /></CloseBtn>
      <Title>Filtres</Title>
      <Filters tooltipPosition="bottom left" tooltipWidth={200} isInSeparateMode />
    </Modal>
  </ScrollLock>
);

FiltersModalWindow.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export { FiltersModalWindow };
